export function normalizeBrokenEmails(raw: string): string {
  let out = String(raw || "");

  out = out.replace(
    /\b([A-Z0-9._%+-]+)\s*@\s*([A-Z0-9.-]+)\s*\.\s*([A-Z]{2,})\b/gi,
    (_match, local: string, domain: string, tld: string) =>
      `${local.trim()}@${domain.trim().replace(/\s+/g, "")}.${tld.trim()}`,
  );

  out = out.replace(
    /\b([A-Z0-9._%+-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+)*)\.\s+([A-Z]{2,})\b/gi,
    (_match, base: string, tld: string) => `${base.trim()}.${tld.trim()}`,
  );

  out = out.replace(
    /\b([A-Z0-9._%+-]+@[A-Z0-9.-]*?[A-Z0-9-]+\.([A-Z]{2,}))(?:\.\2)+(?:\/)?\b/gi,
    (_match, email: string) => email.trim(),
  );

  return out;
}

export function stripLeakedLinkArtifacts(raw: string): string {
  let out = normalizeBrokenEmails(raw);

  // Normalize malformed markdown links like:
  // [Calendario AVAST](https://x.com/" target="_blank" rel="noopener noreferrer")
  out = out.replace(
    /\[([^\]]{1,160})\]\s*\((https?:\/\/[^)\s"']+)\/?"[\s\S]*?\)/gi,
    (_match, rawLabel: string, rawUrl: string) => {
      const label = String(rawLabel || "").trim();
      const url = String(rawUrl || "").trim();
      return label ? `${label}: ${url}` : url;
    },
  );

  // Convert malformed HTML-anchor leakage into readable text.
  // Example:
  // https://x.com/" target="_blank" rel="noopener noreferrer">Calendario
  out = out.replace(
    /(https?:\/\/[^\s)"']+)\/?"\s*target\s*=\s*"_blank"\s*rel\s*=\s*"(?:noopener noreferrer|noreferrer noopener)"\s*>\s*([^\n<]+)/gi,
    (_match, rawUrl: string, rawLabel: string) => {
      const url = String(rawUrl || "").trim();
      const label = String(rawLabel || "")
        .trim()
        .replace(/^["'>\s]+|["'<\s]+$/g, "")
        .replace(/[.:;,!?]+$/g, "");
      if (!label) return url;
      if (/^https?:\/\//i.test(label)) return url;
      return `${label}: ${url}`;
    },
  );

  // Fix malformed markdown URLs like:
  // [Label](https://x.com/" target="_blank" rel="noopener noreferrer")
  out = out.replace(
    /(https?:\/\/[^\s)"']+)\/?"\s*target\s*=\s*"_blank"\s*rel\s*=\s*"noopener noreferrer"\s*>?/gi,
    "$1",
  );

  // Remove leaked anchor attributes that sometimes land as plain text.
  out = out
    .replace(/\s*target\s*=\s*"_blank"/gi, "")
    .replace(/\s*rel\s*=\s*"noopener noreferrer"/gi, "")
    .replace(/\s*rel\s*=\s*"noreferrer noopener"/gi, "")
    .replace(/\s*noopener\s+noreferrer/gi, "")
    .replace(/\s*noreferrer\s+noopener/gi, "")
    .replace(/\s*>\s*/g, " ");

  // Normalize accidental duplicate quote suffix after URL.
  out = out.replace(/(https?:\/\/[^\s)"']+)\/?"/gi, "$1");

  out = out
    .replace(/\r\n/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/[ \t]{2,}/g, " ");

  return out.trim();
}
